var React = require('react');
var firebase = require('../../../firebase');
var toastr = require('toastr');
var when = require('when');

var { fbStorage, fbDb } = firebase;

var Button = require('react-bootstrap/lib/Button');
var Modal = require('react-bootstrap/lib/Modal');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');
import Iframe from 'react-iframe'

var Maps = React.createClass({

  	getInitialState() {
    	return {
    		opened: false,
    		lat: "",
    		lon: "",
    		date: ""
    	};
  	},
  	/*load: function() {
  		var me = this, courierKey = me.props.rowData.id;
  		me.state.lat = "";
  		me.state.lon = "";
  		me.state.date = "";
  		if(me.props.rowData.coordinate) {
  			me.state.lat = me.props.rowData.coordinate.lat;
  			me.state.lon = me.props.rowData.coordinate.lon;
  			me.state.date = me.props.rowData.coordinate.date;
  		}
  		return me.state.lat != "" && me.state.lon != "" && me.state.date != "";
  	},*/
  	open() {
  		var me = this, courierKey = me.props.rowData.id;

  		toastr.success('Localizando...');
  		
  		if(courierKey != "" && courierKey != null) {
  			var request = require('request');
			var options = {
			    url: 'https://us-central1-ajato-29abc.cloudfunctions.net/courier_update_location?courier='+courierKey,
			    method: 'GET'
			}

			request(options, function (error, response, body) {
				//console.log("error: "+error);
				//console.log("response: "+JSON.stringify(response));
				//console.log("body: "+body);
			})

  			setTimeout(function () {
		        me.localize();
		    }, 4000);
  		}
  	},

  	localize() {
  		var me = this, courierKey = me.props.rowData.id;

  		if(courierKey != "" && courierKey != null) {
  			var ref = fbDb.ref('courierLocation/'+courierKey);

			ref.once("value", (snap) => {
				var data = snap.val();

				if (data != null) {
					if(data.date != null && data.lat != null && data.lon != null) {
						me.state.lat = data.lat;
			  			me.state.lon = data.lon;
			  			me.state.date = data.date;
			  			this.setState({opened: true});
					} else {
						toastr.error('Entregador não encontrado.');
					}
				} else {
					toastr.error('Entregador não encontrado.');
				}
			});
  		} else {
  			toastr.error('Entregador não encontrado.');
  		}
  	},

  	close() {
  	  this.setState({opened: false});
  	},
  	render() {
		var me = this;
		let _lat = me.state.lat;
		let _lon = me.state.lon;
		let _date = me.state.date;
		var url = "https://www.google.com/maps/embed/v1/search?q="+_lat+"%2C%20"+_lon+"&key=AIzaSyD7TVBw-CXPNTpcOHwTSTiIcQF8ta_iRzY";

		var date = new Date(_date);
		var hours = date.getHours();
		var minutes = date.getMinutes();
		var seconds = date.getSeconds();
		var day = date.getDate();
		var month = date.getMonth() + 1;
		var year = date.getFullYear();
		if(day < 10)
			day = "0"+day;
		if(month < 10)
			month = "0"+month;
		if(hours < 10)
			hours = "0"+hours;
		if(minutes < 10)
			minutes = "0"+minutes;
		if(seconds < 10)
			seconds = "0"+seconds;
		var lastUpdate = "Última atualização: "+day+"/"+month+"/"+year+" "+hours+":"+minutes+":"+seconds;

    	return (
    		<div>
	    		<Button 
	    			onClick={me.open}
	    			bsSize="small"
	    			bsStyle="primary">
	    			{"Rastrear entregador"}
	    		</Button>
	    		
	    		<Modal show={me.state.opened} onHide={me.close}>

					<ControlLabel>{lastUpdate}</ControlLabel>
					<Iframe url={url}
			        width="600px"
			        height="450px"
			        display="initial"
			        position="relative"
			        allowFullScreen/>
				</Modal>
	    	</div>
    	);
  	}

});

module.exports = Maps;


// WEBPACK FOOTER //
// ./src/components/Admin/Couriers/Maps.jsx